/* Speradik — 2 hats for $80. Pure offer logic: slot state, money, availability pruning.

   No DOM, no fetch, no theme globals, so tests/speradik_hat_model_oracle.js can execute it
   directly in node. The HTML mockup and the shipped theme load THIS FILE unchanged, which is
   what keeps the Liquid port a markup substitution rather than a JS rewrite.

   Price is enforced by the store's automatic discount ($25 off each hat at qty 2+,
   gid://shopify/DiscountAutomaticNode/1504065126623). This module never touches prices; it only
   decides what the shopper has selected and what line items that becomes. */
window.speradikHatModel = (function () {
  'use strict';

  var PAIR_SIZE = 2;

  /* Derived from PAIR_SIZE, never a hardcoded [null, null]: two sources of truth for "two"
     means a change to one of them silently half-applies. */
  function createState() {
    var slots = [];
    for (var i = 0; i < PAIR_SIZE; i++) { slots.push(null); }
    return { slots: slots };
  }
  function clone(s) { return { slots: s.slots.slice() }; }

  function count(s) {
    var n = 0;
    for (var i = 0; i < PAIR_SIZE; i++) { if (s.slots[i] !== null && s.slots[i] !== undefined) n++; }
    return n;
  }

  function firstOpen(s) {
    for (var i = 0; i < PAIR_SIZE; i++) { if (s.slots[i] === null) return i; }
    return -1;
  }

  /* Fill the next open slot. When the pair is already full, evict slot 0 and shift left, so the
     OLDEST selection is the one replaced and the caller can name it in the swap notice. A third
     tap that silently did nothing would leave the shopper stuck with no stated reason. */
  function select(s, variantId) {
    var next = clone(s);
    var open = firstOpen(next);
    if (open > -1) { next.slots[open] = variantId; return { state: next, swappedOut: null }; }
    var evicted = next.slots[0];
    next.slots[0] = next.slots[1];
    next.slots[1] = variantId;
    return { state: next, swappedOut: evicted };
  }

  /* Removing compacts left, so slot 0 always holds the oldest surviving pick and the eviction
     order above stays true after any sequence of removals. */
  function removeSlot(s, i) {
    var next = clone(s);
    if (i < 0 || i >= PAIR_SIZE) return { state: next };
    next.slots.splice(i, 1);
    next.slots.push(null);
    return { state: next };
  }

  /* Collapse duplicates: two of one hat is ONE line at quantity 2, which is the shape
     /cart/add.js and the discount both expect. Two lines of quantity 1 is a different cart. */
  function items(s) {
    var order = [], qty = {};
    s.slots.forEach(function (id) {
      if (id === null) return;
      if (!qty[id]) { qty[id] = 0; order.push(id); }
      qty[id] += 1;
    });
    return order.map(function (id) { return { id: id, quantity: qty[id] }; });
  }

  function totals(unitPrice, pairPrice) {
    var was = unitPrice * PAIR_SIZE;
    return { was: was, now: pairPrice, save: was - pairPrice };
  }

  function ctaState(s) {
    var n = count(s);
    return n === 0 ? 'empty' : (n < PAIR_SIZE ? 'partial' : 'ready');
  }

  /* A pick restored from sessionStorage, or a hat that sold out while the page was open, must
     not reach submit. Keeps whatever is still buyable rather than clearing the whole pair. */
  function pruneUnavailable(s, catalog) {
    var live = {};
    (catalog || []).forEach(function (c) { if (c.available !== false) live[String(c.id)] = true; });
    var next = createState(), dropped = [];
    s.slots.forEach(function (id) {
      if (id === null) return;
      if (live[String(id)]) next = select(next, id).state;
      else dropped.push(id);
    });
    return { state: next, dropped: dropped };
  }

  return {
    PAIR_SIZE: PAIR_SIZE,
    createState: createState,
    clone: clone,
    count: count,
    select: select,
    removeSlot: removeSlot,
    items: items,
    totals: totals,
    ctaState: ctaState,
    pruneUnavailable: pruneUnavailable
  };
})();
